// NOTICE: KAPTION-INTEGRATION - whatsapp-flows: Flows library, detail and
// responses. The pages gate on KAPTION_WHATSAPP_FLOWS themselves (the API
// answers 404 while the flag is off), like the campaign reports page.
import { frontendURL } from '../../../helper/URLHelper';

const KaptionWhatsappFlowsPage = () => import('./KaptionWhatsappFlowsPage.vue');
const KaptionWhatsappFlowDetailPage = () =>
  import('./KaptionWhatsappFlowDetailPage.vue');
const KaptionWhatsappFlowResponsesPage = () =>
  import('./KaptionWhatsappFlowResponsesPage.vue');

const meta = { permissions: ['administrator', 'agent'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/whatsapp-flows'),
    name: 'kaption_whatsapp_flows_index',
    meta,
    component: KaptionWhatsappFlowsPage,
  },
  {
    path: frontendURL('accounts/:accountId/whatsapp-flows/:inboxId/:flowId'),
    name: 'kaption_whatsapp_flow_detail',
    meta,
    component: KaptionWhatsappFlowDetailPage,
  },
  {
    path: frontendURL(
      'accounts/:accountId/whatsapp-flows/:inboxId/:flowId/responses'
    ),
    name: 'kaption_whatsapp_flow_responses',
    meta,
    component: KaptionWhatsappFlowResponsesPage,
  },
];
